import type { FC, ReactNode } from 'react';
import type { VariantProps } from 'class-variance-authority';

import { sidebarContainerClasses } from './classes';

interface SidebarContainerProps extends VariantProps<typeof sidebarContainerClasses> {
  children: ReactNode;
  className?: string;
}

export const SidebarContainer: FC<SidebarContainerProps> = ({ children, className, maxWidth }) => {
  return <div className={sidebarContainerClasses({ maxWidth, className })}>{children}</div>;
};
